<template>
  <div class="content-holder">
    <div class="form-holder acct-transfer">
      <ul class="clearfix">
        <li class="f-left">
          <label for="">{{$t("transactions.list_of_transactions")}}</label>
          <select @change="changeTransactionType" class="drop-search" name="">
            <option value="DEPOSITS">{{$t("transactions.deposits")}}</option>
            <option value="WITHDRAWALS">{{$t("transactions.withdrawals")}}</option>
            <option value="BONUS">{{$t("transactions.bonus")}}</option>
            <option value="TRANSACTIONS">{{$t("transactions.deposit_transactions")}}</option>
          </select>
        </li>
        <li class="f-middle" v-if="type == 'DEPOSITS' || type == 'WITHDRAWALS'">
          <label for="">{{$t("transactions.filter_by")}}</label>
          <select @change="filter_withdraw =1;listing()" class="drop-search" name="filter_deposit" v-model="filter_deposit" v-if="type == 'DEPOSITS'">
            <option v-for="value,key in static_vars.transactionFilter.deposit" :key="key" :value="key">{{value}}</option>
          </select>
          <select @change="filter_deposit =1;listing()" class="drop-search" name="filter_withdraw" v-model="filter_withdraw" v-if="type == 'WITHDRAWALS'">
            <option v-for="value,key in static_vars.transactionFilter.withdrawal" :key="key" :value="key">{{value}}</option>
          </select>
        </li>

        <li class="f-right" v-if="type == 'DEPOSITS' || type == 'WITHDRAWALS' || type == 'BONUS'">
          <label for="">{{$t("transactions.select_trading_id")}}</label>
          <select class="drop-search" name="search" v-model="search" @change="listing()">
            <option value="">{{$t("transactions.all")}}</option>
            <!-- <option v-for="list in GetliveAccount" :key="list.account_id" :value="list.account_id" >{{list.account_id}} ({{(list.demo_live == '1')?'Live' :'Demo'}})</option> -->
            <optgroup label="Live MT4">
                <option :value="list.account_id" v-for="list,index in MergeAcc('1','MT4')" :key ="index" >{{list.account_id}}</option>
              </optgroup>
              <optgroup label="Live MT5">
                <option :value="list.account_id" v-for="list,index in MergeAcc('1','MT5')" :key ="index" >{{list.account_id}}</option>
              </optgroup>
              <optgroup label="Live ZTP">
                <option :value="list.account_id" v-for="list,index in MergeAcc('1','ZTP')" :key ="index" >{{list.account_id}}</option>
              </optgroup>
          </select>
        </li>
      </ul>
    </div>
    <div v-if="type == 'DEPOSITS'" class="table-holder table-holder2 t-center">
      <table>
        <thead>
          <tr>
            <th>{{$t("transactions.date")}}</th>
            <th>{{$t("transactions.account_id")}}</th>
            <th>{{$t("transactions.currency")}}</th>
           <!--  <th>Payment Type</th> -->
            <th>{{$t("transactions.payment_mode")}}</th>
            <th>{{$t("transactions.deposit_amount")}}</th>
            <th>{{$t("transactions.status")}}</th>
          </tr>
        </thead>
        <tbody v-if="store.depositsList.records.length">
          <tr
            v-for="item in store.depositsList.records"
            :key="item.transaction_id"
          >
            <td>{{ COMMON.formatDate(item.created) }}</td>
            <td>{{ item.account_id }}-{{ item.platform }}</td>
            <td>{{ item.currency }}</td>
            <!-- <td>{{ static_vars.depositType[item.deposit_type] }}</td> -->
            <td>
              {{ static_vars.visibleMethods[item.deposit_method] }}
            </td>
            <td>{{ item.amount }}</td>
            <td>{{ static_vars.depositStatus[item.payment_status] }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="6" class="t-center">{{$t("transactions.no_deposits_yet")}}</td>
          </tr>
        </tbody>
      </table>
      <Pagination
        :totalRecords="store.depositsList.totalRecords"
        :pageNo="page"
      />
    </div>
    <div
      v-if="type == 'WITHDRAWALS'"
      class="table-holder table-holder2 t-center"
    >
      <table>
        <thead>
          <tr>
            <th>{{$t("transactions.date")}}</th>
            <th>{{$t("transactions.account_id")}}</th>
            <th>{{$t("transactions.currency")}}</th>
           <!--  <th>Withdrawal Type</th> -->
            <th>{{$t("transactions.withdrawal_mode")}}</th>
            <th>{{$t("transactions.withdrawal_amount")}}</th>
            <th>{{$t("transactions.status")}}</th>
            <th>{{$t("transactions.action")}}</th>
          </tr>
        </thead>
        <tbody v-if="store.withdrawalsList.records.length">
          <tr
            v-for="item in store.withdrawalsList.records"
            :key="item.transaction_id"
          >
            <td>{{ COMMON.formatDate(item.created) }}</td>
            <td>{{ item.account_id }}</td>
            <td>{{ item.currency }}</td>
            <!-- <td>{{ static_vars.withdrawalType[item.withdrawal_type] }}</td> -->
            <td>{{ static_vars.visibleMethods[item.withdrawal_method] }}</td>
            <td>{{ item.amount }}</td>
            <td>{{ static_vars.withdrawalStatus[item.withdrawal_status] }}</td>
            <td>
              <button @click="goToTicketDetails(item.ticket_id)" class="btn btn-blue">
                {{$t("transactions.view_more")}}
              </button>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="6" class="t-center">{{$t("transactions.no_withdrawals_yet")}}</td>
          </tr>
        </tbody>
      </table>
      <Pagination
        :totalRecords="store.withdrawalsList.totalRecords"
        :pageNo="page"
      />
    </div>
    <div v-if="type == 'BONUS'" class="table-holder table-holder2 t-center">
      <table>
        <thead>
          <tr>
            <th>{{$t("transactions.date")}}</th>
            <th>{{$t("transactions.account_id")}}</th>
            <th>{{$t("transactions.currency")}}</th>
           <!--  <th>Bonus Type</th> -->
            <th>{{$t("transactions.bonus_amount")}}</th>
            <th>{{$t("transactions.status")}}</th>
          </tr>
        </thead>
        <tbody v-if="store.bonusList.records.length">
          <tr
            v-for="item in store.bonusList.records"
            :key="item.transaction_id"
          >
            <td>{{ COMMON.formatDate(item.created) }}</td>
            <td>{{ item.account_id }}-{{ item.platform }}</td>
            <td>{{ item.currency }}</td>
            <!-- <td>{{ static_vars.bonusType[item.bonustype] }}</td> -->
            <td>{{ item.amount }}</td>
            <td>{{ item.bonus_status == "1" ? "Completed" : $t('transactions.pending') }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5" class="t-center">{{$t("transactions.no_bonus_transactions_yet")}}</td>
          </tr>
        </tbody>
      </table>
      <Pagination :totalRecords="store.bonusList.totalRecords" :pageNo="page" />
    </div>
    <div v-if="type == 'TRANSACTIONS'" class="table-holder table-holder2 t-center">
      <table>
        <thead>
          <tr>
            <th>{{$t("transactions.date")}}</th>
            <th>{{$t("transactions.account_id")}}</th>
            <th>{{$t("transactions.deposit_currency")}}</th>
           <!--  <th>Bonus Type</th> -->
            <th>{{$t("transactions.account_currency")}}</th>
            <th>{{$t("transactions.address")}}</th>
          </tr>
        </thead>
        <tbody v-if="store.depositTransactionList.records.length">
          <tr
            v-for="item in store.depositTransactionList.records"
            :key="item.account_id"
          >
            <td>{{ COMMON.formatDate(item.dep_time) }}</td>
            <td>{{ item.account_id }}</td>
            <td>{{ item.dep_curr }}</td>
            <!-- <td>{{ static_vars.bonusType[item.bonustype] }}</td> -->
            <td>{{ item.acc_curr }}</td>
            <td>{{ item.dep_address }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5" class="t-center">{{$t("transactions.no_bonus_transactions_yet")}}</td>
          </tr>
        </tbody>
      </table>
      <Pagination :totalRecords="store.depositTransactionList.totalRecords" :pageNo="page" />
    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/store";
import Pagination from "@/components/shared/Pagination";

export default {
  setup() {
    const store = useMainStore();
    return { store };
  },
  data() {
    return {
      type: "DEPOSITS",
      page: 1,
      search : '',
      filter_deposit : 1,
      filter_withdraw : 1

    };
  },
  components: { Pagination },
  computed : {
    GetliveAccount(){
      return this.store.tradingAccounts.records.filter(val => parseInt(val.demo_live) == 1).map(i => i);
    },
  },
  mounted() {
    if (!this.store.depositsList.records.length) {
      const params = {
        type: "DEPOSITS",
        page: "1",
        perPage: this.static_vars.limitPerPage,
        search: this.search,
        sort: [],
      };
      this.store.getTransactionsList(params, false);
    }
  },
  methods: {
     MergeAcc(acc_type,platform){
        let demoMT4 = this.store.tradingAccounts.records.filter(i => i.demo_live == acc_type && i.platform == platform).map(val => val)
        return demoMT4 || []
    },
    changeTransactionType(e) {
      this.search = ''
      this.type = e.target.value;
      this.page = 1;
      this.listing();
    },
    goToTicketDetails(id) {
      this.$router.push({ path: "ticket-details", query: { id } });
    },
    listing() {
      const params = {
        type: this.type,
        page: this.page,
        perPage: this.static_vars.limitPerPage,
        search: '',
        sort: [],
        filter : {}
      };
      if(this.type == 'DEPOSITS'){
        params.filter['deposit.deposit_type'] = this.filter_deposit
      }
      if(this.type == 'WITHDRAWALS'){
        params.filter['withdrawal.withdrawal_type'] = this.filter_withdraw
      }
      if(this.search != ''){
        params.account_id = this.search
      }
      this.store.getTransactionsList(params, true);
    },
  },
};
</script>
